<script setup lang="ts">
import type { ArticleResourceDetailed } from "@carnet/api/backoffice";

defineProps<{ article: ArticleResourceDetailed }>();
</script>

<template>
  <div class="bg-elevated grow">
    <AppSection :ui="{ base: 'py-8 md:pb-10' }">
      <slot />
      <h1 class="text-4xl md:text-6xl font-semibold">{{ article.title }}</h1>
    </AppSection>

    <AppSection class="bg-white" :ui="{ base: 'pt-10 pb-20 md:pt-20 md:pb-25' }">
      <AppSafeHtml
        class="cms-content [--content-col-gap:--spacing(12)] [--content-col-left:calc(5/12*(100%-var(--content-col-gap)))]"
        :content="sanitizeHtml(article.richContent)"
      />
    </AppSection>
  </div>
</template>
